export enum BILLING_ADDRESS_TYPE {
    same = 'same',
    different = 'different',
}
